import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { useSelector } from "react-redux";
import FormattedAmount from "vino/core/FormattedAmount";
import { getFrequencyText } from "utils";

const OrderSummary = () => {
	const subscription = useSelector(({ vino }) => vino.wineClubs.data);

	if (!subscription) {
		return null;
	}
	const { name, price, bottles, frequency } = subscription;
	const frequencyText = getFrequencyText(frequency);
	return (
		<div className="w-full pl-10 ">
			<div className="px-8 pt-20">
				<Typography className="text-16 font-medium">
					Subscription summary
				</Typography>
			</div>
			<div className="px-24">
				<OrderSummaryItem title="Club name" value={name} />
				<OrderSummaryItem
					title=""
					value={`Curated selection of ${bottles} bottles, ${frequencyText}`}
				/>
				<OrderSummaryItem
					title="Price / year"
					value={<FormattedAmount value={price} />}
				/>
			</div>
		</div>
	);
};

export default OrderSummary;

const OrderSummaryItem = ({ title, value }) => {
	return (
		<>
			<div className="flex justify-between w-full my-12">
				{title && (
					<Typography className="text-15 font-medium">{title}</Typography>
				)}

				<div className="flex items-center">
					<Typography className="font-medium ">
						<span className="font-medium ">{value}</span>
					</Typography>
				</div>
			</div>
			<Divider className="my-5" />
		</>
	);
};
